module.exports = __webpack_public_path__ + "static/img/static/img/pre_max.4a4c5167.png";